export default {
    pathName: "",  //路径
    token:'', //token
    userData:{}  //用户数据
}